module.exports = __webpack_public_path__ + "static/media/libro-abierto.4de9ce7f.png";